import React from 'react';
import {observer} from 'mobx-react';
import { action, makeObservable } from 'mobx';
import {withState} from 'shared/core';
import Spinner from 'shared/components/spinners/Spinner';

class EmojiPickerState {
  Picker;
  data;

  constructor() {
    makeObservable(this, {
      load: action
    });
  }

  async load() {
    const modules = await Promise.all([
      import('@emoji-mart/react'),
      import('@emoji-mart/data')
    ]).catch(e => {
      if (!(/Loading chunk .* failed/.test(e.message))) {
        throw e;
      }
    });

    if (modules) {
      const [picker, data] = modules;
      this.Picker = picker.default;
      this.data = data.default;
    }
  }
}

class EmojiPicker extends React.Component {
  rootRef = React.createRef();

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick, true);
    document.addEventListener('touchstart', this.handleDocumentClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick, true);
    document.removeEventListener('touchstart', this.handleDocumentClick, true);
  }

  handleDocumentClick = evt => {
    const root = this.rootRef.current;
    if (root && !root.contains(evt.target)) {
      this.props.onClickOutside();
    }
  };

  render() {
    const {onEmojiClick, className, showPicker, onPickerClick, uiState} = this.props;
    const {Picker, data} = uiState;

    if (!Picker) {
      return null;
    }

    return (
      <div className={className} ref={this.rootRef}>
        <div
          className={'bg-hover-smoke bg-haze px1 rounded2 jumbo border border--whale table'}
          onClick={() => onPickerClick()}
        >
          <div className='table-cell'>
            <i
              className='material-symbols-solid jumbo clickable align-bottom'
              style={{height: '22px', verticalAlign: 'text-top', fontSize: '20px'}}
            >
              {'insert_emoticon'}
            </i>
          </div>
          <div className='jumbo table-cell align-middle ml1'>{'+'}</div>
        </div>
        {showPicker &&
          <div className='table-cell align-top absolute z-index-2 mt1'>
            <Picker data={data} set='native' theme='light' onEmojiSelect={emoji => onEmojiClick(emoji)}/>
          </div>
        }
      </div>
    );
  }
}

EmojiPicker.defaultProps = {
  showPicker: false
};

export default withState(observer(EmojiPicker), EmojiPickerState, {
  spinner: Spinner
});
